import modal from './js/_modal';
import Modal from './react/Modal';
export { modal };
export { Modal as ModalReact };
export default Modal;